import React from 'react'
import { QRCodeCanvas } from 'qrcode.react'

interface IProps {
  closeModal: () => void
  qrCodeValue: string
}

const QrcodeBotGenerateModel: React.FC<IProps> = ({ closeModal, qrCodeValue }) => {
  return (
    <div className='card w-300px h-300px mb-4 position-relative text-center'>
      {/* Close Button */}
      <button
        type='button'
        className='btn-close position-absolute top-0 end-0 m-n4 rounded-circle'
        aria-label='Close'
        onClick={closeModal}
        style={{
          backgroundColor: 'rgba(218, 222, 243)',
          height: '25px',
          width: '25px',
          color: 'rgba(52, 60, 106)'
        }}
      ></button>

      {/* Header */}
      <div className='d-flex justify-content-between align-items-center px-3 py-2'>
        <h2 className='mb-0'>Scan QR Code</h2>
      </div>

      {/* QR Code */}
      <div
        className='d-flex align-items-center justify-content-center mt-10'
        style={{ cursor: 'pointer' }}
      >
        <QRCodeCanvas value={qrCodeValue} size={200} />
      </div>
    </div>
  )
}

export default QrcodeBotGenerateModel
